export default {
    actions: Array, 
    animation: Boolean | Object, 
    appendTo: Object | String, 
    autoFocus: Boolean, 
    content: String | Object, 
    draggable: Boolean | Object, 
    iframe: Boolean, 
    height: Number | String, 
    maxHeight: Number, 
    maxWidth: Number, 
    minHeight: Number, 
    minWidth: Number, 
    modal: Boolean | Object, 
    pinned: Boolean, 
    position: Object, 
    resizable: Boolean, 
    scrollable: Boolean, 
    title: String | Boolean | Object, 
    visible: Boolean, 
    width: Number | String, 
    size: String, 

    // Events
    activate: Function, 
    close: Function, 
    deactivate: Function, 
    dragend: Function, 
    dragstart: Function, 
    error: Function, 
    maximize: Function, 
    minimize: Function, 
    open: Function, 
    refresh: Function, 
    resize: Function
}


// WEBPACK FOOTER //
// ./packages/kendo-window-vue-wrapper/src/KendoWindow/WindowProps.js